module.exports = __webpack_public_path__ + "img/free.d8ef771d.png";